"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TreeShowWrapper = function TreeShowWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "currentTreeModuleId", _descriptor, _this);
      if (!_state.AppUI.layout.isNative && _state.AppUI.userIsLoaded && !_state.AppUI.user.pendingGuestDecision) {
        _state.AppUI.createEvent('stories - view content tree');
      }
      if (!_state.TreeUI.userTreeNodeStore.hasIndexData || _state.AppUI.layout.isNative) {
        _state.TreeUI.userTreeNodeStore.getIndex();
      }
      if (!_state.TreeUI.storiesTree) {
        _state.TreeUI.loadTreesFromTargetLanguage(_state.AppUI.targetLanguageId, _this.scrollToLastActiveTreeNode);
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showLevelWarning",
      get: function get() {
        return _state.AppUI.targetLanguage && _state.AppUI.targetLanguage.contentTreeDecksFinishedCount < 3 && (!_state.AppUI.targetLanguage.levelId || _state.AppUI.targetLanguage.studentGreaterThanA1) && !_state.AppUI.wasUiElementSeen('level-warning');
      }
    }, {
      key: "showNewStoriesWarning",
      get: function get() {
        var _TreeUI$storiesTree;
        return _state.AppUI.targetLanguage && _state.AppUI.targetLanguage.contentTreeDecksFinishedCount < 3 && !_state.AppUI.wasUiElementSeen("new-".concat((_TreeUI$storiesTree = _state.TreeUI.storiesTree) === null || _TreeUI$storiesTree === void 0 ? void 0 : _TreeUI$storiesTree.languageId, "-stories-warning"));
      }
    }, {
      key: "nextTreeNode",
      get: function get() {
        if ((0, _utils.isBlank)(_state.AppUI.targetLanguage.lastActiveTreeNodeId) || !_state.TreeUI.userTreeNodeStore.hasIndexData || (0, _utils.isBlank)(_state.TreeUI.storiesTree)) {
          return;
        }
        var lastActiveTreeNodeIndex = _state.TreeUI.storiesTree.treeNodes.map(function (item) {
          return item.id;
        }).indexOf(_state.AppUI.targetLanguage.lastActiveTreeNodeId);
        if ((0, _utils.isPresent)(lastActiveTreeNodeIndex) && _state.TreeUI.storiesTree.treeNodes.length > lastActiveTreeNodeIndex + 1) {
          var treeNodes = _state.TreeUI.storiesTree.treeNodes.slice(lastActiveTreeNodeIndex);
          if (_state.AppUI.layout.isNative) {
            treeNodes = treeNodes.filter(function (item) {
              return item.mobilePublished;
            });
          } else {
            treeNodes = treeNodes.filter(function (item) {
              return item.webPublished;
            });
          }
          var _iterator = _createForOfIteratorHelper(treeNodes),
            _step;
          try {
            var _loop = function _loop() {
                var treeNode = _step.value;
                var userTreeNode = _state.TreeUI.userTreeNodeStore.indexData.find(function (item) {
                  return item.treeNodeId === treeNode.id;
                });
                if ((0, _utils.isBlank)(userTreeNode) || userTreeNode.finishedUserDecksCount < treeNode.treeNodeDecksCount) {
                  return {
                    v: treeNode
                  };
                }
              },
              _ret;
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _ret = _loop();
              if (_ret) return _ret.v;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }, {
      key: "scrollToNextTreeNode",
      value: function scrollToNextTreeNode() {
        var _this$nextTreeNode,
          _this2 = this;
        if (!_state.AppUI.layout.isNative && (0, _utils.isPresent)((_this$nextTreeNode = this.nextTreeNode) === null || _this$nextTreeNode === void 0 ? void 0 : _this$nextTreeNode.id)) {
          var _this$nextTreeNode2;
          var treeNodeElement = document.getElementById((_this$nextTreeNode2 = this.nextTreeNode) === null || _this$nextTreeNode2 === void 0 ? void 0 : _this$nextTreeNode2.id);
          if ((0, _utils.isPresent)(treeNodeElement)) {
            treeNodeElement.scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            });
          } else {
            this.currentTreeModuleId = this.nextTreeNode.treeModuleId;
            setTimeout(function () {
              var _this2$nextTreeNode;
              treeNodeElement = document.getElementById((_this2$nextTreeNode = _this2.nextTreeNode) === null || _this2$nextTreeNode === void 0 ? void 0 : _this2$nextTreeNode.id);
              if ((0, _utils.isPresent)(treeNodeElement)) {
                treeNodeElement.scrollIntoView({
                  block: 'center',
                  behavior: 'smooth'
                });
              }
              _this2.currentTreeModuleId = null;
            }, 500);
          }
        }
      }
    }, {
      key: "scrollToNewTreeNode",
      value: function scrollToNewTreeNode() {
        if (!_state.AppUI.layout.isNative) {
          var newTreeNodeElements = document.getElementsByClassName('new');
          if ((0, _utils.isPresent)(newTreeNodeElements)) {
            newTreeNodeElements[0].scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            });
          }
        }
      }
    }, {
      key: "treeNodeIconWidth",
      get: function get() {
        if (!_state.AppUI.layout.viewportWidth) {
          return 0;
        }
        var calculatedWidth = (_state.AppUI.layout.viewportWidth - 20) / 3 - 20;
        return Math.min(calculatedWidth, 120);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showLevelWarning: this.showLevelWarning,
          treeNodeIconWidth: this.treeNodeIconWidth,
          showNewStoriesWarning: this.showNewStoriesWarning,
          nextTreeNode: this.nextTreeNode,
          scrollToNextTreeNode: this.scrollToNextTreeNode,
          currentTreeModuleId: this.currentTreeModuleId,
          scrollToNewTreeNode: this.scrollToNewTreeNode
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "currentTreeModuleId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "showLevelWarning", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showLevelWarning"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showNewStoriesWarning", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showNewStoriesWarning"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nextTreeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nextTreeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scrollToNextTreeNode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "scrollToNextTreeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "scrollToNewTreeNode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "scrollToNewTreeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "treeNodeIconWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "treeNodeIconWidth"), _class2.prototype), _class2)) || _class;
};
TreeShowWrapper.displayName = 'TreeShowWrapper';
var _default = exports["default"] = TreeShowWrapper;